import React from 'react';
import useGetLegalDocuments from '../../data/winefo-public/use-get-legal-documents';
import LegalDocuments from '../../components/legal-documents/legal-documents';
import { LegalDocumentType } from '../../models/legal-documents';

const TermsAndConditions: React.FC = () => {
  const { data } = useGetLegalDocuments('TNC');

  return (
    <LegalDocuments
      documentLocations={data?.documentLocations}
      type={LegalDocumentType.TERMS_AND_CONDITIONS}
    />
  );
};

export default TermsAndConditions;
